module.exports = __webpack_public_path__ + "static/media/logo-v2.767cbdd7.svg";